import * as React from 'react';
import { Table, TableHead, TableCell, TableRow, TableBody, Switch, Typography, Link } from '@material-ui/core';
import { ModuleEnum } from 'src/constants/Enum/ModuleEnum';

export default class SurveyModuleComponent extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.assignUnassignModel = this.assignUnassignModel.bind(this);
    }

    assignUnassignModel(isChecked: any, event: any) {

        const selectedModel = {
            id: event.target.value,
            isChecked
        };

        this.props.AssignUnassignModel([], selectedModel);
    }

    render() {
        const modelTypes: any = [];
        return (
            <div className="pageSurveyContentSection">
                <Table className="">
                    <TableHead>
                        <TableRow>
                            <TableCell> <b> Categories</b></TableCell>
                            <TableCell >Sub-categories > <b> Modules</b></TableCell>
                            <TableCell> <b> Contents</b> </TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            this.props.models && this.props.models.map((mod: any, key: any) => {
                                const isPresent = modelTypes.filter((item: any) => (item === mod.module_type));
                                if (!isPresent.length) {
                                    modelTypes.push(mod.module_type);
                                }
                                return <TableRow key={key} className={isPresent && isPresent.length ? '' : 'moduleCategoryName'}>
                                    <TableCell component="th" scope="row"><b>{isPresent && isPresent.length ? '' : mod.module_type}</b></TableCell>
                                    <TableCell >{mod.module_category && (mod.module_category + " > ")}<b>{mod.name}</b></TableCell>
                                    <TableCell> <Typography variant="caption" className="tablePageIndex">
                                        <Link href="#">
                                            {mod.pages} Pages
                                            </Link>
                                        <Link href="#">
                                            {mod.questions} Questions
                                            </Link>
                                    </Typography>
                                    </TableCell>
                                    <TableCell >
                                        <div>
                                            {mod.id !== ModuleEnum.IntroToDataCollection ?
                                                <Switch
                                                    checked={mod.isChecked ? true : false}
                                                    value={mod.id}
                                                    color="primary"
                                                    onChange={this.assignUnassignModel.bind(this, mod.isChecked)}
                                                /> : ""
                                            }
                                        </div>
                                    </TableCell>
                                </TableRow>
                            })
                        }

                    </TableBody>
                </Table>
                {/* </Paper> */}

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/surveys/SurveyModuleComponent.tsx